declare const __AURA_UI_VERSION__: string | undefined;

type RuntimeEnvMap = Record<string, string>;
const RUNTIME_ONLY_KEYS = new Set(['VITE_API_BASEPATH', 'VITE_ENFORCE_ISO27002_SECURITY_CONTROLS']);

const getRuntimeEnv = (): RuntimeEnvMap => {
    if (typeof window === 'undefined') return {};
    const runtime = (window as typeof window & { __AURA_RUNTIME_CONFIG__?: unknown }).__AURA_RUNTIME_CONFIG__;
    if (!runtime || typeof runtime !== 'object') return {};

    const out: RuntimeEnvMap = {};
    for (const [key, value] of Object.entries(runtime as Record<string, unknown>)) {
        if (value != null) out[key] = String(value);
    }
    return out;
};

export const getEnv = (key: string, fallback = ''): string => {
    const runtime = getRuntimeEnv();
    if (runtime[key] != null) return runtime[key];

    const im: any =
        typeof import.meta !== 'undefined' && (import.meta as any).env ? (import.meta as any).env : undefined;
    const isDevMode = !!im?.DEV || (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development');

    // Keep runtime-only behavior in production, but ease local dev when runtime-config.js is not set.
    if (RUNTIME_ONLY_KEYS.has(key) && !isDevMode) return fallback;

    if (im && im[key] != null) return String(im[key]);

    if (key === 'AURA_UI_VERSION' && typeof __AURA_UI_VERSION__ !== 'undefined') {
        return __AURA_UI_VERSION__;
    }
    if (typeof process !== 'undefined' && process.env && process.env[key] != null) {
        return String(process.env[key]);
    }
    return fallback;
};

export const getEnvBool = (key: string, fallback = false): boolean => {
    const raw = getEnv(key, fallback ? 'true' : 'false');
    const val = String(raw).trim().toLowerCase();
    return val === '1' || val === 'true' || val === 'yes' || val === 'on';
};

export const getApiBaseUrl = (): string => {
    const base = getEnv('VITE_API_BASEPATH', '');
    if (!base) return '';
    return base.replace(/^https?:\/\//, '//').replace(/\/api\/v\d+$/, '');
};
